import $ from "jquery";
export const externalLinks = {
    init: ($target) => {
        const fileExtension = new RegExp("\\w*\\.(pdf|doc|docx|xlsx|xls|txt|html|csv|ppt|pptx)$");
        if ($target instanceof $ === false) {
            $target = $(document);
        }
        let filesToRefer = Array.prototype.slice
            .call($target.find("a[href]"))
            .filter((item) => {
            let urlpartExt = item.href.split("?")[0];
            return (fileExtension.test(urlpartExt) ||
                !item.href.startsWith(window.location.origin));
        });
        filesToRefer.forEach((anchor) => {
            $(anchor).attr("target", "_blank");
        });
    },
};
